import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { Icon } from "@/lib/icon";
import { INDUSTRIES, FACTORY_IMAGE } from "@/lib/site-data";

export default function Industries() {
    return (
        <div data-testid="page-industries">
            <PageHeader
                overline="Industries Served"
                title="Built around the realities of Indian industry."
                subtitle="From auto OEMs running JIT supply to engineering manufacturers moving heavy fabrication — we operate where it matters."
                image={FACTORY_IMAGE}
                breadcrumb={[{ label: "Industries" }]}
                testId="industries-header"
            />

            <section className="bg-white py-20 md:py-24">
                <div className="container-vl grid grid-cols-1 md:grid-cols-2 gap-6">
                    {INDUSTRIES.map((ind) => (
                        <article
                            key={ind.slug}
                            data-testid={`industry-detail-${ind.slug}`}
                            className="relative bg-[#101A2C] text-white overflow-hidden border border-[#28406A] group"
                        >
                            <img
                                src={ind.image}
                                alt={ind.title}
                                className="absolute inset-0 w-full h-full object-cover opacity-25 transition-transform duration-500 group-hover:scale-105 group-hover:opacity-40"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-tr from-[#101A2C] via-[#101A2C]/85 to-[#101A2C]/40" />
                            <div className="relative p-8 md:p-10 min-h-[280px] flex flex-col">
                                <Icon name={ind.icon} className="h-10 w-10 text-[#F4A000] mb-5" strokeWidth={1.5} />
                                <h2 className="font-display uppercase text-2xl md:text-3xl mb-3">{ind.title}</h2>
                                <p className="text-sm md:text-base text-[#CBD5E1] leading-relaxed max-w-md mb-6">{ind.body}</p>
                                <Link
                                    to="/contact"
                                    data-testid={`industry-cta-${ind.slug}`}
                                    className="mt-auto inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-[#F4A000] border-b border-[#F4A000] pb-0.5 w-fit"
                                >
                                    Plan {ind.title} Logistics <ArrowRight className="h-3 w-3" />
                                </Link>
                            </div>
                        </article>
                    ))}
                </div>
            </section>

            <section className="bg-[#E9EEF3] py-16" data-testid="industries-cta">
                <div className="container-vl text-center">
                    <p className="overline mb-3">Don't see your industry?</p>
                    <h2 className="heading-h2 text-[#101A2C] mb-6 max-w-3xl mx-auto">
                        We design supply chains for any manufacturing-heavy industry.
                    </h2>
                    <Link to="/contact" data-testid="industries-final-cta" className="btn-primary">
                        Talk to Supply Chain Expert
                    </Link>
                </div>
            </section>
        </div>
    );
}
